import { render, staticRenderFns } from "./RefCategoriesList.vue?vue&type=template&id=e1464d50&scoped=true"
import script from "./RefCategoriesList.vue?vue&type=script&lang=js"
export * from "./RefCategoriesList.vue?vue&type=script&lang=js"
import style0 from "./RefCategoriesList.vue?vue&type=style&index=0&id=e1464d50&prod&lang=scss&scoped=true"
import style1 from "./RefCategoriesList.vue?vue&type=style&index=1&id=e1464d50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1464d50",
  null
  
)

export default component.exports